/*@ngInject*/
const UIDraggableRowDirective = function ($rootScope, $timeout, formMediator, formViewerConstant, authorizationConstants, currentUserModel) {

    let linkFunction = function ($scope, $elm) {

        let element = $($elm),
            selectionContainer = element.find('.rowSelectionContainer'),
            rootFormId = $scope.rowStructure.rootFormId,
            isTopDropAttempt,
            isBottomDropAttempt,
            userCanManageForms = currentUserModel.hasAuthorization(authorizationConstants.MANAGE_FORMS);

        if (userCanManageForms) {
            element.attr('draggable', 'true');
        }

        function selectThisRow () {
            $rootScope.$broadcast(formViewerConstant.configuration.event.FIELD_SELECTION_CHANGE, null);
            $rootScope.$broadcast(formViewerConstant.configuration.event.ROW_SELECTION_CHANGE, $scope.rowStructure);
            $timeout(function () {}, 0);
        }

        function onMouseUp (event) {
            let className = event.target.className;

            if (isRowTarget(className)) {
                selectThisRow();
            }
        }

        function onMouseMove(event) {
            let className = event.target.className;

            if (isRowTarget(className)) {
                selectionContainer.addClass('selectable');
            }
            else {
                selectionContainer.removeClass('selectable');
            }
        }

        function onMouseLeave(event) {
            selectionContainer.removeClass('selectable');
        }

        function isRowTarget (targetClassName) {
            let isClickingRow = targetClassName.indexOf('rowEditor') !== -1,
                isClickingSelectionContainer = targetClassName.indexOf('rowSelectionContainer') !== -1;

            return isClickingRow || isClickingSelectionContainer;
        }


        function onDragStart(event) {
            let className = event.target.className;
            if (isRowTarget(className)) {
                selectThisRow();
            }

            let dataTransfer = event.originalEvent.dataTransfer,
                isDraggingRow = isRowTarget(event.target.className),
                dragConfiguration = {
                    formStructureType: formViewerConstant.configuration.formStructureType.ROW,
                    dragType: formViewerConstant.configuration.dragOperationType.MOVE,
                    rowStructureId: $scope.rowStructure.rowStructureId
                };

            if (isDraggingRow) {
                element.addClass('dragging');
                dataTransfer.effectAllowed = 'move';
                event.originalEvent.dataTransfer.setData('text', JSON.stringify(dragConfiguration));
                formMediator.setCurrentDragItem(dragConfiguration);
            }
        }

        function onDragOver(event) {
            let dataTransfer = event.originalEvent.dataTransfer,
                currentTarget = $(event.currentTarget),
                isElementBeingDragged = currentTarget.hasClass('dragging'),
                currentDragConfig = formMediator.getCurrentDragItem(),
                isDraggingRow = !_.isNil(currentDragConfig) && currentDragConfig.formStructureType === formViewerConstant.configuration.formStructureType.ROW,
                isDraggingRowRepeater = !_.isNil(currentDragConfig) && currentDragConfig.formStructureType === formViewerConstant.configuration.formStructureType.ROW_REPEATER,
                takeActionOnDragEvent = !isElementBeingDragged && (isDraggingRow || isDraggingRowRepeater),
                offsetY,
                height;

            if (takeActionOnDragEvent) {
                offsetY = event.clientY - element.offset().top;
                height = currentTarget.height();
                isTopDropAttempt = offsetY < (height / 2);
                isBottomDropAttempt = offsetY > (height / 2);

                element.removeClass('dragOverTop');
                element.removeClass('dragOverBottom');

                if (isTopDropAttempt) {
                    element.addClass('dragOverTop');
                } else if (isBottomDropAttempt) {
                    element.addClass('dragOverBottom');
                }

                dataTransfer.dropEffect = 'move';
                event.preventDefault();
            }
        }

        function onDragLeave() {
            element.removeClass('dragOverTop');
            element.removeClass('dragOverBottom');
        }

        function handleMoveDropOperation(dropConfiguration) {
            let elementToMoveRowId = dropConfiguration.rowStructureId,
                elementToMoveSelector = '.' + elementToMoveRowId,
                elementToMove,
                dropZoneRowId = $scope.rowStructure.rowStructureId,
                dropZoneTarget,
                takeAction = isTopDropAttempt || isBottomDropAttempt;

            if (takeAction) {
                dropZoneTarget = $('.' + dropZoneRowId);
                elementToMove = $(elementToMoveSelector).detach();

                elementToMove.removeClass('dragging');

                if (isTopDropAttempt) {
                    formMediator.moveRow(rootFormId, elementToMoveRowId, dropZoneRowId, formViewerConstant.configuration.INSERT_ABOVE);
                    elementToMove.insertBefore(dropZoneTarget);
                }
                else if (isBottomDropAttempt) {
                    formMediator.moveRow(rootFormId, elementToMoveRowId, dropZoneRowId, formViewerConstant.configuration.INSERT_BELOW);
                    elementToMove.insertAfter(dropZoneTarget);
                }
            }
        }

        function handleInsertDropOperation(dropConfiguration) {
            let takeAction = isTopDropAttempt || isBottomDropAttempt,
                moveActionResult,
                newRowConfiguration,
                dropZoneRowId = $scope.rowStructure.rowStructureId;

            if (takeAction) {
                if (isTopDropAttempt) {
                    moveActionResult = formMediator.createRowRepeater(rootFormId, dropConfiguration, dropZoneRowId, formViewerConstant.configuration.INSERT_ABOVE);
                }
                else {
                    moveActionResult = formMediator.createRowRepeater(rootFormId, dropConfiguration, dropZoneRowId, formViewerConstant.configuration.INSERT_BELOW);
                }

                newRowConfiguration = {
                    rowStructure: moveActionResult.movedElement,
                    dropZoneRow: element,
                    createAfterDropZone: isBottomDropAttempt
                };

                $rootScope.$broadcast(formViewerConstant.configuration.event.CREATE_NEW_ROW_REPEATER, newRowConfiguration);
            }
        }

        function onDrop(event) {
            let dataTransfer = event.originalEvent.dataTransfer,
                dropConfiguration = JSON.parse(dataTransfer.getData('text')),
                isInsertDropOperation = dropConfiguration.dragType === formViewerConstant.configuration.dragOperationType.INSERT,
                isMoveDropOperation = dropConfiguration.dragType === formViewerConstant.configuration.dragOperationType.MOVE,
                currentDragConfig = formMediator.getCurrentDragItem(),
                isDraggingRow = currentDragConfig.formStructureType === formViewerConstant.configuration.formStructureType.ROW || currentDragConfig.formStructureType === formViewerConstant.configuration.formStructureType.ROW_REPEATER;

            if(isDraggingRow) {
                if (isInsertDropOperation) {
                    handleInsertDropOperation(dropConfiguration);
                }
                else if (isMoveDropOperation) {
                    handleMoveDropOperation(dropConfiguration);
                }

                element.removeClass('dragOverTop');
                element.removeClass('dragOverBottom');

                event.preventDefault();
                return false;
            }
        }

        function onDragEnd(event) {
            let className = event.target.className;

            element.removeClass('dragOverTop');
            element.removeClass('dragOverBottom');
            element.removeClass('dragging');

            if (isRowTarget(className)) {
                selectThisRow();
            }
        }

        element.on('mouseup', onMouseUp);
        element.on('mouseleave', onMouseLeave);
        element.on('mousemove', onMouseMove);
        element.on('dragstart', onDragStart);
        element.on('dragover', onDragOver);
        element.on('dragleave', onDragLeave);
        element.on('drop', onDrop);
        element.on('dragend', onDragEnd);

        $scope.$on(formViewerConstant.configuration.event.DELETE_ROW, function (event, rowStructureId) {
            if ($scope.rowStructure.rowStructureId === rowStructureId) {
                $scope.resetRow(element.parent(), $scope.rowStructure);
            }
        });

        $scope.$on(formViewerConstant.event.formBuilder.DISABLE_DRAGGABLE_ELEMENTS, function () {
            element.attr('draggable', 'false');
        });

        $scope.$on(formViewerConstant.event.formBuilder.ENABLE_DRAGGABLE_ELEMENTS, function () {
            element.attr('draggable', 'true');
        });

        $scope.$on('$destroy', function () {
            element.off('mouseup', onMouseUp);
            element.off('mouseleave', onMouseLeave);
            element.off('mousemove', onMouseMove);
            element.off('dragstart', onDragStart);
            element.off('dragover', onDragOver);
            element.off('dragleave', onDragLeave);
            element.off('drop', onDrop);
            element.off('dragend', onDragEnd);
        });
    };

    return {
        link: linkFunction,
        restrict: 'A'
    };
};

angular.module('umFormViewer')
    .directive('uiDraggableRow', UIDraggableRowDirective);
